// extracted by mini-css-extract-plugin
module.exports = {"link":"BuyNowCta_link__gsZoG","nui-active":"BuyNowCta_nui-active__9tB2I"};